import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

// VFX: Stamp Impact
// Category: text-animations · Tags: stamp, impact, text, bold, slam
export default function TextStampInImpact300Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const p = spring({ frame, fps, config: { damping: 14, stiffness: 220, mass: 0.6 } });
  const scale = interpolate(p, [0, 0.6, 1], [3.5, 1.1, 1]);
  const blur = interpolate(p, [0, 0.5, 1], [24, 6, 0], { extrapolateRight: "clamp" });
  const opacity = interpolate(p, [0, 0.3], [0, 1], { extrapolateRight: "clamp" });
  const rotate = interpolate(p, [0, 1], [-8, -3]);
  const shake = Math.sin(frame * 0.5) * (1 - p) * 4;

  return (
    <AbsoluteFill style={{
      background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
      alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        transform: `scale(${scale}) rotate(${rotate}deg) translate(${shake}px, ${shake}px)`,
        filter: `blur(${blur}px)`,
        opacity,
        padding: "32px 64px",
        border: "8px solid #991b1b",
        borderRadius: 8,
        background: "rgba(220, 38, 38, 0.05)",
      }}>
        <span style={{
          fontSize: 144, fontWeight: 900, color: "#991b1b",
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          fontFamily: "Georgia, serif",
        }}>APPROVED</span>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
